"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.reflect.construct.js");
require("core-js/modules/es.symbol.to-primitive.js");
require("core-js/modules/es.date.to-primitive.js");
require("core-js/modules/es.symbol.js");
require("core-js/modules/es.symbol.description.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.symbol.iterator.js");
require("core-js/modules/es.array.iterator.js");
require("core-js/modules/es.string.iterator.js");
require("core-js/modules/web.dom-collections.iterator.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ScoringForm = void 0;
require("core-js/modules/es.array.find.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.array.join.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.split.js");
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.object.get-prototype-of.js");
var _react = _interopRequireDefault(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _utils = require("../../common/utils");
var _constants = require("../../common/constants");
var _FormControls = require("../../go/components/common/FormControls");
var _TextBoxField = require("../../go/components/common/FormControls/TextBoxField/TextBoxField");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var ScoringForm = /*#__PURE__*/function (_React$Component) {
  _inherits(ScoringForm, _React$Component);
  var _super = _createSuper(ScoringForm);
  function ScoringForm(props) {
    var _this;
    _classCallCheck(this, ScoringForm);
    _this = _super.call(this, props);
    _this.handleChange = function (name, value) {
      _this.setState(_defineProperty({}, name, value));
    };
    _this.saveScorePanelData = function (name) {
      var _this$props = _this.props,
        factor = _this$props.factor,
        part = _this$props.part,
        partId = _this$props.partId,
        entityDataPath = _this$props.entityDataPath,
        saveEntityData = _this$props.saveEntityData,
        validationId = _this$props.validationId,
        options = _this$props.options,
        version = _this$props.version,
        sortOrder = _this$props.sortOrder;
      var _this$state = _this.state,
        value = _this$state.value,
        justification = _this$state.justification;
      saveEntityData(entityDataPath, 'panelReview', {
        factor: factor,
        part: part,
        partId: partId,
        justification: justification,
        text: _lodash.default.get(_lodash.default.find(options, {
          value: value
        }), 'label'),
        // get label to save per architectural guidance
        value: value,
        version: version,
        sortOrder: sortOrder
      }, validationId + '.' + name);
    };
    _this.handleRadio = function (e) {
      _this.setState({
        value: _lodash.default.toNumber(e.target.value)
      }, function () {
        _this.saveScorePanelData(_constants.SCORE);
      });
    };
    _this.handleCustom = function (e) {
      //Workaround to using toNumber raw, saves as a string
      //Doesn't save the entered value to state if it is not a number
      //Blocks entering non number chars if there is a valid number already in state
      //Decimals are allowed, which is why it is implemented like this
      var inputValue = e.target.value;
      if (!_lodash.default.isEqual(_lodash.default.toNumber(inputValue), NaN)) {
        _this.setState({
          value: inputValue
        });
      }
    };
    _this.saveCustom = function () {
      //This exists because until blur the value is being handled as a string
      //previously it was converted to a number in the saveScorePanelData call
      //however this had the effect of _.toNumber(null) = 0 breaking all of the validations for scores
      var value = _this.state.value;
      _this.setState({
        value: !value ? null : _lodash.default.toNumber(value)
      }, function () {
        _this.saveScorePanelData(_constants.SCORE);
      });
    };
    var _this$props2 = _this.props,
      _justification = _this$props2.justification,
      text = _this$props2.text,
      _value = _this$props2.value;
    _this.state = {
      justification: _lodash.default.get(_this.props, "data.".concat(_constants.JUSTIFICATION)),
      value: _lodash.default.get(_this.props, 'data.value')
    };
    return _this;
  }
  _createClass(ScoringForm, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props3 = this.props,
        guidance = _this$props3.guidance,
        hideScore = _this$props3.hideScore,
        hideJustification = _this$props3.hideJustification,
        options = _this$props3.options,
        part = _this$props3.part,
        partId = _this$props3.partId,
        factor = _this$props3.factor,
        validationErrors = _this$props3.validationErrors,
        validationDirtyMap = _this$props3.validationDirtyMap,
        anchorLinkText = _this$props3.anchorLinkText,
        customInput = _this$props3.customInput;
      var _this$state2 = this.state,
        value = _this$state2.value,
        justification = _this$state2.justification;
      var scoreError = (0, _utils.getFirstErrorForField)(validationErrors, _constants.SCORE);
      var scoreDisplayError = scoreError !== undefined && _lodash.default.get(validationDirtyMap, "dirty.".concat(_constants.SCORE));
      var scoreErrorMessage = _lodash.default.get(scoreError, 'message', false);
      var justificationError = (0, _utils.getFirstErrorForField)(validationErrors, _constants.JUSTIFICATION);
      var justificationDisplayError = justificationError !== undefined && _lodash.default.get(validationDirtyMap, "dirty.".concat(_constants.JUSTIFICATION));
      var justificationErrorMessage = _lodash.default.get(justificationError, 'message', false);
      var generateAnchorLink = function generateAnchorLink() {
        var anchorLink = _this2.props.anchorLink;
        var link = anchorLink ? "#".concat(anchorLink) : "#item-".concat(_lodash.default.join(_lodash.default.split(partId, '.'), '-'));
        var title = "Open ".concat(anchorLinkText);
        return /*#__PURE__*/_react.default.createElement("a", {
          href: link,
          className: "w-inline-block padding-bottom--double"
        }, title);
      };
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("p", null, guidance), anchorLinkText && generateAnchorLink(), customInput && /*#__PURE__*/_react.default.createElement(_TextBoxField.InlineTextBoxField, {
        id: "".concat(partId, "-").concat(factor, "-score"),
        name: "".concat(partId, "-").concat(factor, "-").concat(_constants.SCORE),
        displayError: scoreDisplayError,
        errorMessages: scoreErrorMessage,
        value: value,
        label: 'Score:',
        handleBlur: this.saveCustom,
        handleChange: this.handleCustom
      }), !hideScore && /*#__PURE__*/_react.default.createElement(_FormControls.RadioField, {
        id: "".concat(partId, "-").concat(factor, "-score"),
        name: "".concat(partId, "-").concat(factor, "-").concat(_constants.SCORE),
        displayError: scoreDisplayError,
        errorMessages: scoreErrorMessage,
        value: value,
        label: 'Score:',
        options: options,
        handleBlur: function handleBlur() {
          return _this2.saveScorePanelData(_constants.SCORE);
        },
        handleChange: this.handleRadio
      }), /*#__PURE__*/_react.default.createElement(_FormControls.TextAreaField, {
        id: "".concat(partId, "-").concat(factor, "-").concat(_constants.JUSTIFICATION),
        name: "".concat(partId, "-").concat(factor, "-").concat(_constants.JUSTIFICATION),
        displayError: justificationDisplayError,
        errorMessages: justificationErrorMessage,
        value: justification,
        hidden: hideJustification,
        label: 'Justification:',
        handleChange: function handleChange(e) {
          return _this2.handleChange(_constants.JUSTIFICATION, e.target.value);
        },
        handleBlur: function handleBlur() {
          return _this2.saveScorePanelData(_constants.JUSTIFICATION);
        }
      }));
    }
  }]);
  return ScoringForm;
}(_react.default.Component);
exports.ScoringForm = ScoringForm;